const APP_IDS = {
  Plants: 'plantsss',
  CVC: 'conocevaloraconserva',
};

export default APP_IDS;
